import React from 'react'
import {useDropFileEvents} from './lib/utils/useDropFileEvents'
import {useShowSampleModal} from './AddStudiesButton'
import {Fill} from '@startlibs/core'
import {DropModal} from './DropModal'

export const FullPageDroppable = ({fileEventHandler}) => {

  const isDragging = useDropFileEvents(fileEventHandler)
  const [showSampleModal] = useShowSampleModal()
  return (showSampleModal || isDragging.isOpen) &&
    <Fill name="Modal">
      <DropModal/>
    </Fill>

}